import React, { useContext } from "react";
import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";

const ShipmentViewToggle = ({children}) => {
    let { shipment, loading, error } = useContext(ShipmentContext);

    if(loading){
        return <><div className="my-10 text-center shipment-status">
            <h1 className="h3">
                <animate class="h-3 bg-lightest-grey rounded-lg text-transparent" data-animation="pulse">Order Status</animate><br/>
                <animate class="h-3 bg-lightest-grey rounded-lg text-transparent" data-animation="pulse">Loading...</animate>
            </h1>
        </div>
        <div className="shipment-summary container container--narrow my-10 flex justify-between gap-5">
            <div className="shipment-summary__item text-center">
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Picked Up:</animate><br/>
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Loading...</animate>
            </div>
            <div className="shipment-summary__item text-center">
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Estimated Delivery:</animate><br/>
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Loading...</animate>
            </div>
            <div className="shipment-summary__item text-center">
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Shipping Company:</animate><br/>
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Loading...</animate>
            </div>
        </div>
        <div className="shipment-map my-10">
            <h2 className="h4 mb-4 text-center">
                <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-3" data-animation="pulse">
                    Order Tracker
                </animate>
            </h2>

            <animate className="shipment-map__container bg-lightest-grey" data-animation="pulse">
            </animate>
        </div>
      </>;
    }else if(error){
        return <div dangerouslySetInnerHTML={{
            __html: window.shipment_tracking.no_tracking_content,
            }}></div>

    }

    if(shipment){
        return <>{children}</>
    }else{
        return <>No shipment</>
    }

};

export default ShipmentViewToggle;